// extracted by mini-css-extract-plugin
export var downArrow = "_k0-0";
export var infoTooltipIcon = "_k0-3";
export var label = "_k0-1";
export var optionCard = "_k0-4";
export var upArrow = "_k0-2";